var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"loading-small-wrapper"},[_c('b-spinner',{staticClass:"loading-small-spinner",attrs:{"variant":"primary","type":"grow","label":_vm.$t('actions.loading')}}),_vm._v(" "+_vm._s(_vm.$t('actions.loading'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }